const buttonKeys = [
  {
    type: 'func',
    value: 'AC',
  },
  {
    type: 'func',
    value: '+/-',
  },
  {
    type: 'func',
    value: '%',
  },
  {
    type: 'operator',
    value: '÷',
  },
  {
    type: 'number',
    value: '7',
  },
  {
    type: 'number',
    value: '8',
  },
  {
    type: 'number',
    value: '9',
  },
  {
    type: 'operator',
    value: 'x',
  },
  {
    type: 'number',
    value: '4',
  },
  {
    type: 'number',
    value: '5',
  },
  {
    type: 'number',
    value: '6',
  },
  {
    type: 'operator',
    value: '-',
  },
  {
    type: 'number',
    value: '1',
  },
  {
    type: 'number',
    value: '2',
  },
  {
    type: 'number',
    value: '3',
  },
  {
    type: 'operator',
    value: '+',
  },
  {
    type: 'number',
    value: '0',
  },
  {
    type: 'number',
    value: '.',
  },
  {
    type: 'operator',
    value: '=',
  },
];

export default buttonKeys;
